<div class="selection-list-container">
	<div class="selection-list-sub-title" *ngIf="data.length && subTitle" (click)="onSubTitleClick()">{{subTitle}}</div>

	<div class="selection-list-items">
		<div *ngFor="let item of data;trackBy:trackByCode"
			 class="selection-list-item"
			 [ngClass]="{'active': item.isActive, 'selected': item.isSelected}"
			 cpDblClick (cpClick)="onSelect(item)" (cpDblClick)="item.actions?.length ? onActionClick($event, item, item.actions[0]) : null">
			<div *ngIf="!itemTemplate">
				<div #description class="description" [innerHTML]="item.description|cpMark:searchTerms:markOperator.Contains"></div>
				<cp-tooltip [anchor]="description" [delay]="800" [keepOpenWhenMouseIn]="true">
					<div class="procedure-description-tooltip">
						<span>{{item.description}}</span>
					</div>
				</cp-tooltip>
				<span class="selection-list-icon-buttons">
					<span *ngFor="let action of item.actions">
						<cp-icon-button class="cp-icon-color-1"
										[icon]="action"
										(iconClick)="onActionClick($event, item, action)">
						</cp-icon-button>
					</span>
				</span>
			</div>

			<ng-template [ngTemplateOutlet]="itemTemplate"
						 [ngTemplateOutletContext]="{$implicit: item}">
			</ng-template>
		</div>
		<ng-content></ng-content>
	</div>
</div>
